import { styled } from '@linaria/react';

export const Button = styled.button`
	line-height: 0;

	&:hover {
		svg {
			color: var(--color-white-solid);
		}
	}

	svg {
		color: var(--color-grey-52-solid);
	}
`;

export const TooltipBox = styled.div`
	width: 300px;
	color: var(--color-white-solid);
`;
